export enum ComparisonMode {
  CHANNEL = "channel",
  GEOGRAPHY = "geography",
  BRAND = "brand",
  CATEGORY = "category",
  PRODUCT = "product",
}

// Add to string conversion with custom labels
export const comparisonModeLabels: Record<ComparisonMode, string> = {
  [ComparisonMode.CHANNEL]: "Channel Comparison",
  [ComparisonMode.GEOGRAPHY]: "Geography Comparison",
  // TODO: Make this label dynamic based on selected BU layer
  [ComparisonMode.BRAND]: "Brand Comparison",
  [ComparisonMode.CATEGORY]: "Category Comparison",
  [ComparisonMode.PRODUCT]: "Product Comparison",
};

export const getComparisonModeLabel = (mode: ComparisonMode) => {
  return comparisonModeLabels[mode];
};

export const comparisonModesRequiringNodeUpdate = [
  ComparisonMode.BRAND,
  ComparisonMode.CATEGORY,
  ComparisonMode.PRODUCT,
];
